import React from 'react'
import { Box, Typography } from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

function AnnouncementBanner({ announcement }) {
  const theme = useTheme()

  return (
    <Box
      display='flex'
      alignItems='center'
      style={{
        gap: theme.spacing(1.5),
        minHeight: 44,
        padding: theme.spacing(1.5, 2),
        borderRadius: 6,
        border: `1px solid ${theme.palette.divider}`,
        borderLeft: `4px solid ${theme.palette.primary.main}`,
        background: theme.palette.background.sectionOddBg
      }}
    >
      <FontAwesomeIcon
        icon={['fal', announcement ? 'bullhorn' : 'bell']}
        style={{ color: theme.palette.primary.main, fontSize: 15, flexShrink: 0 }}
      />
      {announcement ? (
        <Typography variant='body2'>{announcement}</Typography>
      ) : (
        <Typography variant='body2' color='textSecondary' style={{ fontStyle: 'italic' }}>
          No announcements at this time.
        </Typography>
      )}
    </Box>
  )
}

export default AnnouncementBanner
